import { FileSystemService } from './file-system.service';

export default angular
  .module('sfMobile.services.file-system', [
    'pascalprecht.translate',
    'sfMobile.services.segment',
    'sfMobile.constants.error-codes',
  ])
  .service('filesSystemService', FileSystemService).name;
